import { Component } from 'react';
import { connect } from 'react-redux';
import { actions, Control, Errors, Form } from 'forms/rrf';
import { Col, Container, Row } from 'react-bootstrap';
import BackLink from '../common/back-link/index';
import ArrowButton from '../common/button-arrow';
import PageTitle from '../common/page-title/index';
import RequiredInput from '../common/form/elements/required-input';
import RequiredSelect from '../common/form/elements/required-select';
import BsRadio from '../common/form/elements/bs-radio';
import { getPage, getPages, getTemplates, savePage, storePage } from '../../actions/pages';

class Page extends Component {
  onSaveClicked = (payload) => {
    const { dispatch, match } = this.props;

    if (match.params.id === undefined) {
      dispatch(actions.submit('deep.page', storePage(payload, match.params.id)));
    } else {
      dispatch(actions.submit('deep.page', savePage(payload, match.params.id)));
    }
  };

  handleNameChange = () => {
    const {
      dispatch, pages, currentName, match
    } = this.props;
    const currentId = match.params.id;
    const taken = !!currentName
      && pages.some(p => p && p.name === currentName && String(p.id) !== String(currentId));

    dispatch({ type: taken ? 'SET_PAGE_NAME_TAKEN' : 'SET_PAGE_NAME_NOT_TAKEN' });
  };

  UNSAFE_componentWillMount() {
    const { dispatch, match } = this.props;

    if (match.params.id === undefined) {
      dispatch(actions.reset('deep.page'));
    } else {
      dispatch(getPage(match.params.id));
    }

    dispatch(getTemplates());
    dispatch(getPages());
    dispatch({ type: 'SET_PAGE_NAME_NOT_TAKEN' });
  }

  render() {
    const {
      fetched, templates, taken, formValid
    } = this.props;

    if (fetched === true) {
      return (
        <div>
          <Form
            model="deep.page"
            onSubmit={this.onSaveClicked}
            validators={{
              '': {
                login_required: vals => vals.login_required
              }
            }}
          >
            <Container fluid className="users">
              <Row>
                <Col lg={12}>
                  <BackLink href="/admin/pages"/>
                </Col>
              </Row>
              <Row>
                <Col lg={12}>
                  <PageTitle>
                    Add/Edit page
                  </PageTitle>
                </Col>
              </Row>
              <Col lg={12}>
                <RequiredInput
                  label="Name"
                  model=".name"
                  onBlur={this.handleNameChange}
                  placeholder="Name"
                />
                {taken && (
                  <div className="errors">
                    <span>
                      Name has been already taken.
                    </span>
                  </div>
                )}
              </Col>
              <Col lg={12}>
                <RequiredSelect
                  label="Page template"
                  model=".page_template"
                  values={templates.templates || []}
                />
              </Col>
              <Col lg={12}>
                <div>
                  Login required*
                </div>
              </Col>
              <Col lg={12}>
                <Row>
                  <Col lg={12}>
                    <Control.radio
                      component={BsRadio}
                      model=".login_required"
                      value="true"
                    >
                      Yes
                    </Control.radio>
                  </Col>
                  <Col lg={12}>
                    <Control.radio
                      component={BsRadio}
                      model=".login_required"
                      value="false"
                    >
                      No
                    </Control.radio>
                  </Col>
                  <Col lg={12}>
                    <Errors
                      className="errors"
                      messages={{login_required: 'You must set if login is required.'}}
                      model=".login_required"
                      show={{touched: true}}
                    />
                  </Col>
                </Row>
              </Col>
              <Row>
                <Col lg={12}>
                  <ArrowButton
                    arrow={false}
                    className="float-end"
                    color="red"
                    disabled={taken || !formValid}
                  >
                    Save
                  </ArrowButton>
                </Col>
              </Row>
            </Container>
          </Form>
        </div>
      );
    }

    return (
      <div>
        Loading...
      </div>
    );
  }
}

const mapStateToProps = state => ({
  pages: Object.values(state.pages.pages || {}).filter(Array.isArray).flat(),
  currentName: (state.deep.page || {}).name,
  templates: state.templates.templates,
  fetched: state.pages.fetched,
  fetching: state.pages.fetching,
  taken: state.pages.pageNameTaken,
  formValid: state.deep.forms.page.$form.valid
});

export default connect(mapStateToProps)(Page);
